import { clamp } from '@mantine/hooks';
import { padTime } from '../pad-time/pad-time.js';
function createTimeHandler(_ref) {
  var onChange = _ref.onChange,
    nextRef = _ref.nextRef,
    min = _ref.min,
    max = _ref.max,
    maxValue = _ref.maxValue;
  return function (value, triggerShift) {
    var _a, _b, _c, _d;
    if (value === "00") {
      onChange("00");
      triggerShift && ((_a = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _a.focus());
      triggerShift && ((_b = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _b.select());
      return;
    }
    var parsed = parseInt(value, 10);
    if (Number.isNaN(parsed)) {
      return;
    }
    if (parsed > maxValue) {
      onChange(padTime(clamp({
        value: parsed,
        min: min,
        max: max
      })));
      triggerShift && ((_c = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _c.focus());
      triggerShift && ((_d = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _d.select());
      return;
    }
    onChange(parsed.toString());
  };
}
export { createTimeHandler };